export const CONTRIBUTION_LIMITS = {
	EMPLOYEE_PLAN: 8500,
	FREELANCE_PLAN: 4250,
	INDIVIDUAL_PLAN: 1500,
	GLOBAL_EMPLOYEE: 10000, // 8500 + 1500
	GLOBAL_FREELANCE: 5750, // 4250 + 1500
	GLOBAL_INDIVIDUAL: 1500, // Solo individual
	HIGH_SALARY_THRESHOLD: 60000,
	// Tope MENSUAL del plan individual (1.500 €/año ÷ 12 = 125 €/mes).
	// El cap del individual es una constante legal estática, así que se deriva en
	// front. Los caps de autónomo/empleado SÍ son dinámicos (dependen del salario y
	// de lo ya aportado en el año) y llegan del backend (calculateMaxAportationsInfo).
	INDIVIDUAL_PLAN_MONTHLY: 125 // 1500 / 12
} as const;

/**
 * Devuelve true si el usuario aplica el cap reducido de autónomo (4.250 plan / 5.750 global).
 * Toda persona autónoma (isFreelance), societaria o pura.
 */
export const usesReducedAutonomoCap = (user?: { isFreelance?: boolean } | null): boolean =>
	!!user?.isFreelance;
